package com.tovtalk.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import coil3.compose.AsyncImage

/**
 * JS (Compose Canvas): loads images via Coil 3 — same as Android/iOS. Coil renders into
 * the Skia canvas so no DOM-overlay hacks are needed.
 */
@Composable
actual fun TovTalkAsyncImage(
    url: String,
    modifier: Modifier,
    clipToCircle: Boolean,
    contentScale: ContentScale
) {
    AsyncImage(
        model = url,
        modifier = modifier,
        contentDescription = null,
        contentScale = contentScale
    )
}
